import script from "./ConsultNontaxAnalysisModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConsultNontaxAnalysisModal.vue?vue&type=script&setup=true&lang=ts"

import "./ConsultNontaxAnalysisModal.vue?vue&type=style&index=0&id=48a5bcdc&lang=scss"

const __exports__ = script;

export default __exports__